import { Alert } from "@iluvatar/ui-kit";

import { lazy, Suspense } from "react";

import { useConnectivityStatus } from "../../contexts/connectivity.context";
import { Banner } from "../Banner";

const UpdateMonitor = lazy(() => import("./UpdateMonitor"));

function ReloadPrompt() {
  const online = useConnectivityStatus();

  return (
    <>
      {!online && (
        <Banner dismissible placement="bottom" style={{ padding: 0 }}>
          <Alert tone="info">
            You have lost connectivity. Some features may not be available
          </Alert>
        </Banner>
      )}
      <Suspense fallback={null}>
        <UpdateMonitor />
      </Suspense>
    </>
  );
}

export default ReloadPrompt;
